import { h, Fragment } from 'preact'
import classnames from 'classnames'
import { Button } from './Button.jsx'


export function SavedJobsButton({ icon, saved, unsave, save, ...props }) {

	const label = !icon ? (saved ? 'Saved' : 'Save') : ''
	return <>
		<Button 
			type="button"
			alt={saved ? 'Saved' : 'Save job'} 
			onClick={saved ? unsave : save} {...props}
			class={saved ? 'job-button-saved' : ''}>
			{label}
		</Button>
	</>
}